export const apiFetch = (url, options = {}) => {
  const headers = {
    Accept: 'application/json',
    ...options.headers,
  };

  return fetch(url, {
    ...options,
    headers,
  });
};

// local
// const API_BASE_URL = `${window.location.origin.replace(/:\d+$/, '')}:3000`;


// export const apiFetchProxy = (url, options = {}) => {
//   const fullUrl = url.startsWith('http') ? url : `${API_BASE_URL}${url}`;

//   const headers = {
//     Accept: 'application/json',
//     ...options.headers,
//   };

//   return fetch(fullUrl, {
//     ...options,
//     headers,
//     credentials: 'include',
//   });
// };



// build
// let cachedConfig = null;
// export const apiFetch = async (url, options = {}) => {
//   if (!cachedConfig) {
//     try {
//       const res = await fetch('/config.json');
//       cachedConfig = await res.json();
//     } catch (error) {
//       console.error('❌ Failed to load config.json:', error);
//       throw error;
//     }
//   }

//   const baseUrl = cachedConfig.REACT_APP_BASE_URL || '';
//   const fullUrl = url.startsWith('http') ? url : `${baseUrl}${url}`;

//   const headers = {
//     Accept: 'application/json',
//     ...options.headers,
//   };

//   return fetch(fullUrl, {
//     ...options,
//     headers,
//     credentials: 'include',
//   });
// };

// proxy

// export const apiFetchProxy = (url, options = {}) => {
//   const headers = {
//     Accept: 'application/json',
//     ...options.headers,
//   };

//   return fetch(url, {
//     ...options,
//     headers,
//   });
// };




